<template>
	<div>
<p class="MsoNormal" align="center" style="text-align:center;">
	<b>自由职业者</b><b>信息综合服务</b><b>协议</b><b></b>
</p>
<p class="MsoNormal">
	&nbsp;
</p>
<p class="MsoNormal">
	<b>【提示</b><b>条款</b><b>】</b><b></b>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	感谢<span>您选择</span>“余米<span>平台</span>”为您提供自由职业者信息综合服务，您将与我司<span>（</span><span>“余米</span>平台”所属企业或关联企业）签署本《自由职业者信息综合服务协议》（下称“本协议”），并为我司的合作企业（以下<span>简称</span>“甲方客户<span>企业</span>”）提供服务。在本协议中您为乙方，我司为甲方。
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span>为维护您的自身权益，在您点击</span><span>“同意”（电子签署）或书面签署本协议之前，请认真阅读本协议，务必审慎阅读、充分理解</span>各条款内容<span>，特别是权利义务条款。以粗体及</span><span>/或下划线标识的</span>条款，您应重点阅读。
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b><u>当您按照提示填写您的个人信息、阅读并同意本协议且完成全部线上申请或书面签署后，即表示您已充分阅读、理解并接受本协议的全部内容，并与我司就本协议内容达成一致意见并</u></b><b><u>成为</u></b><b><u>我司</u></b><b><u>的合作伙伴</u></b><b><u><span>，此后您不得以未阅读</span><span>/不理解本协议内容或类似言辞做任何形式的抗辩。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，请您立即停止任何的线上申请/注册或书面签署程序。</span></u></b><b><u></u></b>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b><u>您</u></b><b><u>与我司通过签署本协议建立经济合作关系，该关系适用</u></b><b><u>《合同法》、《民法总则》和其他民事法律，不适用《劳动法》、《劳动合同法》。</u></b><b><u></u></b>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b><u>&nbsp;</u></b>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b>【特别提示】</b><b></b>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b>针对获得生产经营所得的自由职业者在使用本协议项下甲方提供的</b><b>自由职业者</b><b>信息综合服务时，甲方承诺依法纳税、确保自然人纳税人取得税后的合法收入。</b><b></b>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b>军人、公职人员等国家法律法规和纪律规定禁止从事兼职或经商的人员，严禁使用本协议项下甲方提供的</b><b>自由职业者</b><b>信息综合服务。</b><b></b>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b><span>公司雇员等其他与公司具有劳动</span><span>/劳务合同关系、或其他类似的劳动人事法律关系并从与其有前述关系的公司取得工资薪金所得的人员，严禁使用本协议项下甲方提供的</span></b><b>自由职业者</b><b>信息综合服务；该类人员因从事生产经营而从非与其有前述关系的企、事业单位所取得的生产经营所得，甲方可为其提供本协议项下的</b><b>自由职业者</b><b>信息综合服务。</b><b></b>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b>公司法定代表人、股东、董事、监事等其他从所属公司取得收入的人员，一律严禁使用本协议项下甲方提供的</b><b>自由职业者</b><b>信息综合服务；该类人员因从事生产经营而从非与其有前述关系的企、事业单位所取得的生产经营所得，甲方可为其提供本协议项下的</b><b>自由职业者</b><b>信息综合服务。</b><b></b>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b>一经发现有上述任一行为的，甲方有权上报税务机关及其他相关国家机关。税务机关及其他相关国家机关根据《中华人民共和国税收征收管理法》及其他相关法律法规的规定追究责任主体的法律责任。</b><b></b>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b>&nbsp;</b>
</p>
<p class="MsoNormal">
	<b>【协议条款】</b><b></b>
</p>
<p class="MsoNormal">
	&nbsp;&nbsp;&nbsp;&nbsp;<b></b>
</p>
<p class="MsoNormal" align="center" style="text-align:center;">
	<b><span>第一章</span> &nbsp;<span>总</span> </b><b>&nbsp;</b><b>则</b><b></b>
</p>
<p class="MsoNormal" style="text-indent:21.1pt;">
	<b>第一条</b>&nbsp;&nbsp;<span>甲方是在</span><span>中国境内注册成立</span>、拥有相关资质的企业，系“余米<span>平台</span>”（<span>以下简称</span>“甲方<span>平台</span>”）所属企业或关联企业，拥有共享经济信息资源平台及管理服务系统，接受乙方委托为其匹配适合的自由<span>职业</span>交易机会，并为乙方提供信息综合服务。<b></b>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b>第二条</b>&nbsp;&nbsp;<span>乙方系具有</span>完全民事行为<span>能力且具备</span>相应<span>专业技能、素养及许可</span>（如有）<span>的自由职业者</span>，接受<span>甲方提供的自由职业者信息综合服务，与甲方</span>客户<span>企业之间建立业务合作关系并</span>为其<span>提供相应的生产经营活动。</span>
</p>
<p class="MsoNormal" style="text-indent:21.1000pt;">
	<b>第三条</b>&nbsp;&nbsp;<span>依据</span><span>《</span>中华人民<span>共和国合同法》</span>、<span>《</span>中华人民共和国税收征收管理法<span>》</span>、<span>《</span>中华人民共和国发票管理办法<span>》</span>、<span>《</span>委托代征管理办法<span>》</span>等<span>相关法律法规</span>的<span>规定，</span>甲、乙双方本着<span>平等自愿、诚实信用的原则，</span><span>经友好协商，就双方</span><span>“自由</span><span>职业者</span>信息<span>综合服务</span>”<span>合作</span>事宜，<span>共同签署本协议</span>，以资共同遵守。
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	&nbsp;
</p>
<p class="MsoNormal" align="center" style="text-align:center;">
	<b><span>第二章</span> &nbsp;<span>服务</span></b><b>内容</b><b></b>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第四条</b>&nbsp;&nbsp;<span>甲方客户</span>企业因生产经营业务需要众多的自由职业者为其或其用户/客户提供服务，乙方为在甲方平台注册的众多的自由职业者之一员，甲方通过其平台居间为乙方及甲方客户企业提供信息综合服务，包括但不限于：
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	（一）为自由职业者提供软件授权使用、账户搭建与管理、交易管理及撮合、交易合同签订与存证、订单管理与查询、信息咨询及管理等信息服务和交易处理等服务。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（二）接受乙方委托为其匹配适合的交易机会（甲方客户企业的服务订单）并根据甲方客户企业委托向乙方结算个体生产经营所得（绩效费），及为乙方代缴个人所得税等税款及相关行政收费（如适用）。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（三）乙方应自行负担就其取得的个体生产经营所得（绩效费）所需缴纳的个税及行政收费（如有），甲方按照有关税收政策规定及甲方主管税务机关的要求，并接受乙方委托为其代办前述税费缴纳；甲方接受乙方委托向对应的甲方客户企业收取乙方应得的个体生产经营所得（绩效费），并将完税之后的金额支付给乙方。<span>甲方将委托具有代征资质授权的服务方（简称</span><span>“甲方委托的服务方”）为乙方代缴个人所得税等税款。</span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	&nbsp;
</p>
<p class="15" align="center" style="text-align:center;">
	<b><span>第三章</span> &nbsp;<span>协议生效</span></b><b>及有效期</b><b></b>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第五条</b>&nbsp;&nbsp;<span>本协议条款若在</span><span>甲方平台或甲方授权的网站</span>上<span>发布，自乙方线上点击确认之日起生效；若为书面签署，自乙方签署本协议之日起生效</span>。本协议<span>有效期</span>为<span>壹年</span>。期限届满，双方应另行签署新的协议；若双方未签署新的协议，而以实际行动继续合作的，视为双方同意协议期限顺延直至按照本协议约定终止或解除时为止。
</p>
<p class="15" style="text-indent:21.0000pt;">
	&nbsp;
</p>
<p class="15" align="center" style="text-align:center;">
	<b><span>第四章</span> &nbsp;<span>权利和义务</span></b><b></b>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b><span>第六条</span> &nbsp;</b>甲方的权利和<span>义务</span>：
</p>
<p class="15" style="text-indent:21.0000pt;">
	（一）甲方<span>有权</span>对乙方<span>提供的信息</span>（包括<span>但不限于乙方姓名、身份证号等</span>）<span>进行验证</span>，<span>但该验证行为</span>并<span>不意味着甲方对乙方信息的真实性、有效性、合法性、完整性负责，也并</span>不因此减轻或免除乙方的任何义务或责任。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（二）甲方作为居间方对<span>乙方提供自由职业者信息综合服务</span>，<span>该服务并不导致甲</span>、<span>乙双方构成任何</span><span>劳动</span><span>/</span><span>劳务合同关系或其他类似劳动人事法律关系，甲方对乙方因从事生产经营动与任一方或第三人所产生的争议不承担任何法律责任。</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	（三）甲方作为居间方，对经过甲方平台信息综合服务促成的甲方<span>客户企业与乙方</span>之间<span>的合作交易</span>所承担的居中协调、监督双方行为等义务并不导致甲方成为责任承担的主体。如甲方客户<span>企业</span>与提供服务的乙方任何一方违反约定，导致甲方或甲方的关联方承担责任的，甲方均可向责任方追偿。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（四）甲方<span>客户企业在乙方为其提供服务期间对乙方提供的生产经营活动制定相应</span>规则及<span>标准，乙方应当遵守前述活动</span>规则<span>及标准。</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	（五）甲方<span>有权协助甲方客户企业对乙方</span>为<span>甲方客户企业提供服务的工作成果进行验收。</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	（六）如乙方与甲方客户<span>企业</span>之间如有非因本协议产生的争议或纠纷的，与甲方无关，甲方不承担任何责任。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（七）甲方协助乙方获取个体生产经营所得时，应当按照有关税收政策规定及甲方主管税务机关授予的代征权限，向乙方代征个人所得税等各项税款及行政收费（如有）。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（八）甲方可以留存为实现本协议合作内容获取的乙方个人信息，但未经乙方授权，甲方不得将乙方个人信息披露给为实现本协议合作目的必须知悉乙方信息之外的任何第三方。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（九）甲方承诺对乙方所披露的个人隐私信息进行保密。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十）甲方承诺将按照相关法律法规的要求，对获取的乙方个人信息履行安全保护义务，保障网络免受干扰、破坏或未经授权的访问，防止网络数据泄露或被窃取、篡改。
</p>
<p class="15" style="text-indent:21.0000pt;">
	<span>（十一）甲方发现乙方违反本协议第七条第（八）款之规定的，甲方有权中止本协议，并将乙方的违法行为自发现之时</span><span>24</span><span>小时之内向甲方主管税务机关报告。乙方应自行承担由此产生的税务相关的处罚责任，包括但不限于根据税务机关的要求补缴相应的税款、滞纳金等。</span>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b><span>第七条</span> &nbsp;</b>乙方的权利和<span>义务</span>：
</p>
<p class="15" style="text-indent:21.0000pt;">
	（一）乙方有权且应当拒绝任何违反法律法规的活动。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（二）乙方确认，其具有民事权利能力及完全民事行为能力，并满足所有履行本协议所需的法定条件或约定条件。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（三）为实现本协议合作之目的，乙方同意甲方及甲方客户企业收集乙方的个人信息，包括但不限于乙方姓名、身份证号、收款账户信息、接单数量及费用等。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（四）乙方发现甲方违反法律、行政法规的规定或者双方的约定收集、使用其个人信息的，有权要求其删除其个人信息；发现甲方收集、存储的其个人信息有错误的，有权要求其予以更正。甲方应当采取措施予以删除或者更正。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（五）乙方保证向<span>甲方及甲方客户</span>企业<span>所</span><span>提供的个人信息等均是真实、有效、合法、完整的，如信息变更应当及时通知甲方，与此有关的全部法律责任由乙方承担。同时，乙方知悉并确认，当且仅当其通过了甲方网站</span><span>/</span><span>系统或甲方授权的第三方网站</span><span>/</span><span>系统的实名认证后，方能享有包括但不限于账户、合同签存及代征代开等综合服务。</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	（六）乙方同意授权并委托甲方为其申请数字证书，并签署所需的相关协议，但该协议应以不加重乙方的合同义务为限。乙方知悉并同意，经数字证书签署后的电子合同，与乙方以纸质形式进行的签章具有同等法律效力，对乙方具有不可撤销的法律约束力。乙方不得以未签署纸质合同为由、或未实际操作数字证书等理由，否认该等电子合同的法律效力。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（七）为便于业务的开展和<span>向乙方提供优质的自由职业者信息综合服务</span>，根据实际业务情况，甲方可能会匹配一家或多家甲方客户<span>企业</span>作为实际业务提供方，为乙方提供本协议项下约定的服务，乙方对此知情并完全同意。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（八）乙方<span>承诺</span>与其<span>正</span>在<span>服务</span>或<span>准备服务的甲方客户企业</span>之间<span>不具有下列关系：</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	1、与甲方客户<span>企业</span><span>具有劳动</span><span>/</span><span>劳务合同关系、或其他类似的劳动人事法律关系的人员；</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	2、与甲方客户<span>企业的</span><span>关联企业具有劳动</span><span>/</span><span>劳务合同关系、或其他类似的劳动人事法律关系的人员；</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	3、为甲方客户<span>企业</span>及其关联企业的法定代表人、董事、监事、股东；
</p>
<p class="15" style="text-indent:21.0000pt;">
	4、其他不适用于本协议适用<span>范围之规定的人员关系。</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	前述甲方客户<span>企业的</span>关联企业是指：与甲方客户<span>企业</span><span>相互间直接或间接持有其中一方的股权总和达到</span><span>25%</span><span>或以上的；或者与甲方客户</span><span>企业</span><span>直接或间接同为第三者所拥有或控制股权达到</span><span>25%</span><span>或以上的；或者对甲方客户</span><span>企业</span>生产经营、交易具有实际控制的与其他利益相关联的关系（包括但不限于婚姻、近亲属关系）。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（九）乙方有义务自行保护其账户信息的安全，任何通过乙方账户进行的操作均将被视为乙方的真实意思表示，相应责任均由乙方自行承担。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十）乙方可自主选择、申请在甲方平台上发布服务工作需求的甲方客户企业并经对方同意作为其服务对象，也可由甲方客户企业直接筛选或委托甲方筛选乙方并经乙方同意为甲方客户企业提供相关服务。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十一）乙方应勤勉<span>履行本协议，维护甲方及甲方客户企业形象，</span>按时尽责地完成甲方客户<span>企业</span>要求的工作内容，并达到规定的质量标准。乙方<span>保证在</span>提供<span>服务过程中</span>不得有侵犯他人知识产权、财产权、人身权、肖像权、隐私权、商业秘密或其他合法权益以及其他违反国家法律法规、国家政策、或有悖于公序良俗等行为，如因<span>乙方个人原因造成其个人或任何第三方损害的责任，由乙方承担全部法律责任。</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十二）甲方<span>及甲方客户企业</span>没有为乙方购买任何保险的法律义务，乙方自行购买商业保险的，其投保、出险及理赔事宜均与甲方及<span>甲方客户企业</span>无关。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十三）乙方应排他性地使用于甲方<span>及甲方客户</span>企业处获得的唯一身份标识，因乙方泄露或提供给他人使用该身份标识而造成的一切后果，由乙方自行承担，与甲方及<span>甲方客户企业</span>无关。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十四）乙方应自备提供生产经营活动所需要的设备设施、自行承担提供生产经营活动的必要费用，甲方<span>客户企业</span>有<span>另行约定的除外</span>。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十五）乙方确认，已知晓其生产经营所得的计算方式、结算周期及支付<span>途径</span>等<span>信息，如有异议，可直接与甲方客户企业沟通，甲方可在必要时提供相关协助</span>。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十六）乙方理解并同意：甲方及甲方委托的<span>服务</span>方对乙方<span>取得的生产</span>经营<span>所得应缴纳的个人所得税及其他相关税费进行代扣代缴。</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十七）乙方理解并同意：甲方及甲方委托的<span>服务</span>方仅能根据主管税务机关授予的委托代征范围、期限、税种、税率等进行代征相关事宜，各地主管税务机关的具体规定可能不一致。同时，如遇国家或地方政府政策变更的，甲方及甲方委托的<span>服务</span>方有权根据变更后的政策规定自动调整本协议项下的权利义务乃至终止本协议。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十八）协议期内，乙方应在甲方及<span>甲方客户企业</span>许可范围内使用本协议有关的商业信息；协议期内以及协议终止后，乙方均有义务对双方合作的有关协议及合作过程中知悉的甲方及<span>甲方客户企业</span><span>的相关信息予以保密，未经书面许可，乙方不得以任何方式向其他方披露、给予或转让该等保密信息，否则，因此导致甲方及</span><span>/</span><span>或甲方客户</span><span>企业</span>或其关联企业的损失，由乙方负责赔偿。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（十九）除本协议事项外，乙方不能以甲方或甲方客户<span>企业</span>的名义开展任何与完成约定的工作任务无关的业务或活动。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（二十）若相关服务通过甲方客户<span>企业</span>指定的网络平台提供，甲方客户<span>企业</span>指定的网络平台可能将要求乙方点击签署电子协议，乙方点击确认后则该协议将对乙方产生法律效力。
</p>
<p class="15" style="text-indent:21.0000pt;">
	&nbsp;
</p>
<p class="15" align="center" style="text-align:center;">
	<b><span>第五章</span> &nbsp;<span>生产经营</span></b><b>所得（</b><b>绩效</b><b>费）</b><b>结算</b><b></b>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第八条</b>&nbsp;&nbsp;<span>结算规则：</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	乙方生产经营所得（绩效费）的结算规则由甲方客户企业与乙方具体确定。
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第九条</b>&nbsp;&nbsp;<span>支付方式：</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	（一）甲方客户<span>企业应支付给乙方的生产经营所得（</span>绩效<span>费）</span>将<span>通过甲方向乙方予以支付。</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	（二）甲方以人民币形式向乙方支付乙方的生产经营所得（绩效费），乙方应缴纳的个人所得税及其他相关税费由甲方负责代扣代缴。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（三）甲方以银行转账方式向乙方支付乙方生产经营所得（绩效费）。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（四）甲方支付乙方生产经营所得（绩效费）以乙方提供的收款账户为准，若乙方的银行账户信息是通过甲方平台/网站在线提供的，以乙方在线提供的信息为准。若因乙方提供的收款账户信息不实造成的一切损失由乙方自行承担；如乙方的收款账户信息变更或发生不可用等情况时，乙方应及时书面通知甲方或在甲方平台/网站进行信息变更操作，否则，由此造成的一切损失由乙方自行负责。
</p>
<p class="15" style="text-indent:21.0000pt;">
	&nbsp;
</p>
<p class="15" align="center" style="text-align:center;">
	<b><span>第六章</span> &nbsp;<span>协议的终止</span></b><b></b>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第十条</b>&nbsp;&nbsp;<span>发生以下</span><span>情形时，本协议终止：</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	（一）协议<span>期限届满或任何</span>一<span>方提前三十日书面通知对方要求终止协议的，但乙方</span>要求<span>终止协议应事先获得</span>其<span>正在提供服务的甲方客户企业的同意且不得影响甲方客户企业的运营</span>；
</p>
<p class="15" style="text-indent:21.0000pt;">
	（二）一方违反协议约定，且违约方在非违约方书面通知后十五日内仍未予改正的，非违约方可以书面通知的形式终止本协议；
</p>
<p class="15" style="text-indent:21.0000pt;">
	（三）乙方提供<span>的服务未能达到甲方客户企业</span>的<span>验收标准</span>，甲方<span>可提前终止本协议；</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	（四）乙方违反本协议第七条第（八）款之规定的，甲方<span>可提前终止本协议</span>。
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第十一条</b>&nbsp;&nbsp;<span>本协议</span><span>的提前终止不影响已经产生的权利义务关系。</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	&nbsp;
</p>
<p class="15" align="center" style="text-align:center;">
	<b><span>第七章</span> &nbsp;<span>违约责任</span></b><b></b>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第十二条</b>&nbsp;&nbsp;<span>任意一方违反本协议约定的视为</span><span>违约方</span>，守约方有权要求违约方在合理期限内纠正，如违约方未及时纠正或纠正后仍不符合本协议要求的，守约方有权单方终止本协议，并要求违约方赔偿守约方因此遭受的直接经济损失（包括律师费、诉讼费等）。
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第十三条</b>&nbsp;&nbsp;<span>因政府行为或不可抗力因素导致本协议部分条款或全部条款无法履行的，遭受该行为的一方不承担违约责任。</span>
</p>
<p class="15" style="text-indent:21.0000pt;">
	&nbsp;
</p>
<p class="15" align="center" style="text-align:center;">
	<b><span>第八章</span> &nbsp;<span>附</span> &nbsp;<span>则</span></b><b></b>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第十四条</b>&nbsp;&nbsp;<span>本协议期满双方不再续约或者因一方违约导致本协议无法履行，则本协议终止。</span>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第十五条</b>&nbsp;&nbsp;<span>本协议未尽事宜或与国家有关法律、法规、规定相悖的，均按国家有关法律、法规、规定执行。</span>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第十六条</b>&nbsp;&nbsp;<span>任何一方就对方针对本协议项下任何条款的违约行为的自动弃权或重复性弃权不应被视为是对下一次针对同一条款的违约行为或针对其它条款的违约行为的弃权。</span>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第十七条</b>&nbsp;&nbsp;<span>除本协议另有约定外，在履行本协议过程中的一切通知，甲方</span><span>将通过甲方平台向乙方发送平台消息的方式送</span>达<span>乙方，甲方将通知消息发出之时</span>即视为<span>甲方完成通知义务。</span>
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第十八条</b>&nbsp;&nbsp;甲、乙双方因执行本协议发生的一切争议，双方应首先友好协商解决。经协商不能解决，可向甲方所在地人民法院提起诉讼。在诉讼期间，除必须在诉讼过程中进行解决的问题外，合同其余部分应继续履行。
</p>
<p class="15" style="text-indent:21.1000pt;">
	<b>第十九条</b>&nbsp;&nbsp;<span>以书面形式</span><span>签署的</span>本协议一式两份，甲乙双方各执一份，具有同等法律效力。
</p>
<p class="15" style="text-indent:21.0000pt;">
	（以下<span>无正文</span>）
</p>
<p class="15" style="text-indent:21.0000pt;">
	&nbsp;
</p>
<p class="15">
	&nbsp;
</p>
<p class="15">
	&nbsp;
</p>
<p class="15">
	<span>甲</span> &nbsp;<span>方（盖章）：</span>
</p>
<p class="15">
	<span>地</span> &nbsp;<span>址：</span>
</p>
<p class="15">
	联系电话：
</p>
<p class="15">
	联系邮箱：
</p>
<p class="15">
	&nbsp;
</p>
<p class="15">
	<span>乙</span> &nbsp;<span>方（姓名）：{{(row)?row.supplierName:""}}</span>
</p>
<p class="15">
	身份证号：{{(row)?row.idCardNumber:""}}
</p>
<p class="15">
	联系电话：{{(row)?row.supplierPhone:""}}
</p>
<p class="15">
	&nbsp;
</p>
<p class="15">
	<span>签署日期：【</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>】年【</span> &nbsp;&nbsp;&nbsp;<span>】月【</span> &nbsp;&nbsp;&nbsp;<span>】日</span>
</p>
</div>
</template>

<script>
	
	export default{
		
		
		props:{
			
			row:Object
			
			
		}
		
		
	}
	
</script>

<style>
</style>
